<template>
  <v-flex class="territory-preview">
    {{ territory.dependent_locality }} <br v-if="territory.dependent_locality">
    {{ renderLocality() }} {{ territory.administrative_area }} <br v-if="territory.locality || territory.administrative_area ">
    {{ territory.country_code | country }} <br>
    {{ renderIncludedPostcodes() }} <br v-if="territory.included_postal_codes">
    {{ renderExcludedPostcodes() }}
  </v-flex>
</template>

<script>
export default {
  name: 'TerritoryPreview',

  props: {
    territory: {
      type: Object,
      required: true
    }
  },

  methods: {
    renderLocality () {
      return this.territory.locality ? this.territory.locality + (this.territory.administrative_area ? ', ' : '') : ''
    },

    renderIncludedPostcodes () {
      return this.territory.included_postal_codes ? `${this.$t('Incl. Postcodes')}: ${this.territory.included_postal_codes}` : ''
    },

    renderExcludedPostcodes () {
      return this.territory.excluded_postal_codes ? `${this.$t('Excl. Postcodes')}: ${this.territory.excluded_postal_codes}` : ''
    }
  }
}
</script>

<style lang="css" scoped>
  .territory-preview {
    cursor:pointer
  }
</style>
